// extracted by mini-css-extract-plugin
export var btnPrimary = "PricingPlan-module--btn-primary--b19d4";
export var btnSecondary = "PricingPlan-module--btn-secondary--9453a";
export var btnWhite = "PricingPlan-module--btn-white--f61d8";
export var plan = "PricingPlan-module--plan--8671c";
export var planButton = "PricingPlan-module--planButton--d9720";
export var planDark = "PricingPlan-module--plan--dark--7783f";
export var planDarkByline = "PricingPlan-module--plan--dark--byline--51507";
export var planDarkDescription = "PricingPlan-module--plan--dark--description--94306";
export var planDarkFeaturesListItem = "PricingPlan-module--plan--dark--features--listItem--31604";
export var planDarkFeaturesTitle = "PricingPlan-module--plan--dark--features--title--533ea";
export var planDarkPayCycle = "PricingPlan-module--plan--dark--payCycle--affb5";
export var planDarkPerStoryPrice = "PricingPlan-module--plan--dark--perStoryPrice--d0379";
export var planDarkPrice = "PricingPlan-module--plan--dark--price--fddb7";
export var planDarkSubTitle = "PricingPlan-module--plan--dark--subTitle--17c80";
export var planDarkTitle = "PricingPlan-module--plan--dark--title--15b94";
export var planLight = "PricingPlan-module--plan--light--779a9";
export var planLightByline = "PricingPlan-module--plan--light--byline--43bc3";
export var planLightDescription = "PricingPlan-module--plan--light--description--0ed9a";
export var planLightFeaturesListItem = "PricingPlan-module--plan--light--features--listItem--4e71e";
export var planLightFeaturesTitle = "PricingPlan-module--plan--light--features--title--c1e61";
export var planLightPayCycle = "PricingPlan-module--plan--light--payCycle--5f0bf";
export var planLightPerStoryPrice = "PricingPlan-module--plan--light--perStoryPrice--ba3fb";
export var planLightPrice = "PricingPlan-module--plan--light--price--1d5ef";
export var planLightSubTitle = "PricingPlan-module--plan--light--subTitle--36e21";
export var planLightTitle = "PricingPlan-module--plan--light--title--669b9";
export var subTitle = "PricingPlan-module--subTitle--3fd7f";